module.exports = __webpack_public_path__ + "img/impression.0deb7ba0.svg";